import React from 'react';
import { Trans } from 'react-i18next';
import InlineError from "../components/common/InlineError";
import log from 'loglevel';

class ErrorBoundary extends React.Component {

  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    log.error({ error, errorInfo });
    if (typeof this.props.onError === 'function') {
      this.props.onError(error);
    }
  }

  reset() {
    this.setState({ hasError: false, error: null });
  }

  render() {
    if (this.state.hasError) {
      if (typeof this.props.fallback === 'function') {
        return this.props.fallback(this.state.error, () => this.reset());
      }
      // InlineError renderiza no lugar da subárvore que crashou — mesma
      // posição visual do banner antigo. Sem botão de dismiss: o reset natural
      // acontece na próxima navegação (subtree remonta) e o boundary já loga
      // via componentDidCatch pro Sentry.
      // <Trans> explícito porque InlineError não traduz keys — a props é texto
      // já resolvido ou ReactNode (contrato dos 4 primitivos de feedback).
      const key = this.props.feedbackKey || 'error.boundary.general';
      return (
        <InlineError title={<Trans i18nKey={key} />} />
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;